import { lazy, Suspense, useState, useCallback } from 'react';

const PrintPopup = lazy(() => import('../../Modals/PrintPopup'));

export const usePrintModal = ({ serverAppTheme }) => {
  const [printRow, setPrintRow] = useState(null);

  const onOpenPrint = useCallback(row => setPrintRow(row), []);
  const onClosePrint = useCallback(() => setPrintRow(null), []);

  const jsx = printRow ? (
    <Suspense fallback={null}>
      <PrintPopup
        row={printRow}
        serverAppTheme={serverAppTheme}
        onClose={onClosePrint}
      />
    </Suspense>
  ) : null;

  return { onOpenPrint, jsx };
};
